module.exports = __webpack_public_path__ + "img/hotel.45080308.svg";